import { CoverageQaSettings } from "@redotech/redo-coverage-common/qa";
import * as z from "zod";

export const getCoverageQa = {
  name: "getCoverageQa" as const,
  input: z.object({ teamId: z.string() }).strict(),
  output: z.object({ settings: CoverageQaSettings }),
};

export const updateCoverageQaSettings = {
  name: "updateCoverageQaSettings" as const,
  input: z.object({ teamId: z.string(), enabled: z.boolean() }).strict(),
  output: z.object({ settings: CoverageQaSettings }),
};
